// Import model
import { ProposalLineCondition } from '../models/ProposalLineCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ProposalLineIndexedFields } from '../models/ProposalLineIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ProposalLineIndexedFieldsSerializer } from './ProposalLineIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ProposalLineCondition - handles JSON serialization and deserialization with type validation
 */
export class ProposalLineConditionSerializer {
  /**
   * Deserializes a JSON string into a ProposalLineCondition instance
   */
  static deserialize(json: string): ProposalLineCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ProposalLineCondition instance
   */
  static fromObject(obj: any): ProposalLineCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ProposalLineCondition');
    }


    const instance: ProposalLineCondition = {
      fieldName: obj['fieldName'] as ProposalLineIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ProposalLineCondition instances
   */
  static deserializeArray(json: string): ProposalLineCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ProposalLineCondition instance to a JSON string
   */
  static serialize(instance: ProposalLineCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ProposalLineCondition instance to a plain object
   */
  static toObject(instance: ProposalLineCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ProposalLineCondition instances to a JSON string
   */
  static serializeArray(instances: ProposalLineCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
